module.exports = __webpack_public_path__ + "img/save.6c3f588e.svg";